module.exports = __webpack_public_path__ + "img/shop_haier_middle.317cb1d7.png";